import { cn } from '@eliadmin/core/src/utils/style-utils';
import { arePathsEqual } from '@eliadmin/core/src/utils/url-utils';
import Link from '@eliadmin/core/src/components/link';
import { GoArrowRight } from 'react-icons/go';

export type ProfileSidebarItemProps = {
  name: string;
  icon: React.ElementType;
  variant?: any;
  href: string | (() => string);
  hardLink?: boolean;
  pathname: string;
};

export const ProfileSidebarItem = ({
  name,
  icon: Icon,
  variant,
  hardLink,
  href,
  pathname,
}: ProfileSidebarItemProps) => {
  const LinkComponent = hardLink ? 'a' : Link;
  const hrefString = typeof href === 'function' ? href() : href;
  const isActive = arePathsEqual(pathname, hrefString);

  return (
    <LinkComponent
      key={hrefString + name}
      href={hrefString ?? '#'}
      className={cn(
        'flex h-[60px] items-center justify-center gap-2 border px-6 transition-all sm:h-16 lg:h-[72px]',
        {
          'pointer-events-none border-black bg-black text-white': isActive,
          'cursor-pointer border-border text-black hover:border-black hover:bg-black hover:text-white':
            !isActive,
        },
      )}
    >
      <Icon size={20} />
      <span className="flex-1">{name}</span>
      <GoArrowRight size={20} />
    </LinkComponent>
  );
};
